import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BantGameReportsService } from './api/bantGameReports.service';
import { GameReportsService } from './api/gameReports.service';
import { GroupReportsService } from './api/groupReports.service';
import { PapReportsService } from './api/papReports.service';
import { ParentReportsService } from './api/parentReports.service';
import { PortfolioManagerReportsService } from './api/portfolioManagerReports.service';
import { PortfolioTeacherReportsService } from './api/portfolioTeacherReports.service';
import { ProfileCopyTokensService } from './api/profileCopyTokens.service';
import { ProfileQrCodesService } from './api/profileQrCodes.service';
import { SchemaService } from './api/schema.service';
import { StemReportsService } from './api/stemReports.service';
import { TeacherReportsService } from './api/teacherReports.service';
import { TransitionReportsService } from './api/transitionReports.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    BantGameReportsService,
    GameReportsService,
    GroupReportsService,
    PapReportsService,
    ParentReportsService,
    PortfolioManagerReportsService,
    PortfolioTeacherReportsService,
    ProfileCopyTokensService,
    ProfileQrCodesService,
    SchemaService,
    StemReportsService,
    TeacherReportsService,
    TransitionReportsService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
